<div class="kitcontainer-table">
    <p-table [value]="data" [columns]="columns" [paginator]="true" [rows]="rows" #kd_table>
      <ng-container *ngIf="title">
        <ng-template pTemplate="caption">
          <h2>{{ title }}</h2>
        </ng-template>
      </ng-container>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngIf="kdHeaderStart">
            <ng-container *ngTemplateOutlet="kdHeaderStart; context: { $implicit: columns}"></ng-container>
          </ng-container>
          <th class="text-center" *ngFor="let col of columns">
            {{ col.header }}
          </th>
          <ng-container *ngIf="kdHeaderEnd">
            <ng-container *ngTemplateOutlet="kdHeaderEnd; context: { $implicit: columns}"></ng-container>
          </ng-container>
        </tr>
        <tr *ngIf="filtersEnabled">
          <ng-container *ngIf="kdHeaderStart">
            <ng-container *ngTemplateOutlet="kdHeaderStart; context: { $implicit: columns}"></ng-container>
          </ng-container>
          <th *ngFor="let col of columns">
            <span class="flex justify-content-center">
              <input pInputText type="text" (input)="onFilter($event, col.field)" placeholder="" class="w-fit"
                *ngIf="col.filter">
            </span>
          </th>
          <ng-container *ngIf="kdHeaderEnd">
            <ng-container *ngTemplateOutlet="kdHeaderEnd; context: { $implicit: columns}"></ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <ng-container *ngIf="kdBodyStart">
            <ng-container *ngTemplateOutlet="kdBodyStart; context: { $implicit: rowData}"></ng-container>
          </ng-container>
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.type">
              <ng-container *ngSwitchCase="'date'">
                <span class="text-center text-nowrap">
                  <p>
                    {{ rowData[col.field] | date: 'dd/MM/yyyy' }}
                  </p>
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'datetime'">
                <span class="text-center text-nowrap">
                  <p>
                    {{ rowData[col.field] | date: 'dd/MM/yyyy HH:mm' }}
                  </p>
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'currency'">
                <span class="text-center text-nowrap">
                  <p>
                    {{ rowData[col.field] | currency: 'EUR' }}
                  </p>
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'url_button'">
                <span class="flex align-items-center justify-content-center">
                  <a style="color: transparent" [href]="rowData[col.field]" target="_blank">
                    <button pButton pRipple type="button" icon="pi pi-send"
                      class="p-button-rounded p-button-warning"></button>
                  </a>
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'boolean_icon'">
                <span class="center_item">
                  <i class="pi"
                    [ngClass]="{ 'true-icon pi-check-circle text-green-500': rowData[col.field], 'false-icon pi-times-circle text-red-500': !rowData[col.field] }"></i>
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'boolean_button'">
                <span class="center_item">
                  <p-button (onClick)="onCheckActivo(rowData)" [icon]="rowData[col.field] ? 'pi pi-check' : 'pi pi-times'"
                    [rounded]="true" [text]="true" [severity]="rowData[col.field] ? 'success' : 'danger'">
                  </p-button>
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'boolean_text'">
                <span class="text-center">
                  <p>{{ rowData[col.field] ? "Sí" : "No" }}</p>
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'percent'">
                <span class="text-center text-nowrap">
                  <p>{{ (toFloat(rowData[col.field]))/100 | percent: '1.0-2' }}</p>
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'editar_texto'">
                <span style="display: flex; justify-content: center;">
                  <input pInputText [(ngModel)]="rowData[col.field]" type="text" placeholder="" class="w-fit">              
                </span>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <span class="text-center text-nowrap">
                  <p>{{ rowData[col.field] }}</p>
                </span>
              </ng-container>
            </ng-container>
          </td>
          <ng-container *ngIf="kdBodyEnd">
            <ng-container *ngTemplateOutlet="kdBodyEnd; context: { $implicit: rowData}"></ng-container>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>